import React from "react"
import "./Resume.scss"
export default function Resume() {
    return <div className="Resume">
    <h2 id="resume"></h2>
    <h2>Resume</h2>
    <iframe src="https://cdn.glitch.com/db1e1209-c792-4734-8e48-9879ea05b807%2FEwenike_Chidi_Resume.pdf?v=1571280224703"
      width="100%" height="500px"></iframe>
    </div>
}